import React from "react";
import styled from "styled-components";
import { fmtN } from "../../../functions/format";
import { CHART_COLORS } from "../../../styles/theme";

/** Liste de barres horizontales : items = [{ name, value, color? }] */
const HBarList = ({
    items = [],
    unit = "",
    color = CHART_COLORS.violetSoft,
}) => {
    const max = Math.max(...items.map((i) => i.value)) || 1;
    return (
        <Wrapper>
            {items.map((item) => (
                <Row key={item.name}>
                    <Name title={item.name}>{item.name}</Name>
                    <Track>
                        <Fill
                            style={{
                                width: `${((item.value / max) * 100).toFixed(
                                    1
                                )}%`,
                                background: item.color || color,
                            }}
                        />
                    </Track>
                    <Value>
                        {fmtN(item.value)}
                        {unit}
                    </Value>
                </Row>
            ))}
        </Wrapper>
    );
};

export default HBarList;

const Wrapper = styled.div`
    margin-top: 8px;
`;

const Row = styled.div`
    display: grid;
    grid-template-columns: 110px 1fr 42px;
    align-items: center;
    gap: 10px;
    margin-bottom: 11px;
    font-size: var(--prh-font-base);
`;

const Name = styled.span`
    color: var(--prh-muted);
    text-align: right;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const Track = styled.div`
    background: var(--prh-bg);
    border-radius: 4px;
    height: 11px;
    overflow: hidden;
`;

const Fill = styled.div`
    height: 100%;
    border-radius: 4px;
    transition: width 0.4s;
`;

const Value = styled.span`
    font-weight: 600;
    font-size: var(--prh-font-base);
`;
